import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FaChevronDown } from 'react-icons/fa';

import * as colors from '../../../styles/colors';

class DropDownMenu extends Component {
  constructor(props) {
    super(props);
    const { children } = this.props;
    this.state = {
      isOpen: false,
      childrenCount: React.Children.count(children),
    };
  }


  render() {
    const { isOpen, childrenCount } = this.state;
    const { children, title, icon } = this.props;
    return (
      <Wrapper>
        <DropDownHead onClick={() => this.setState({ isOpen: !isOpen })}>
          <Left>
            <IconWrapper>
              {
                icon
              }
            </IconWrapper>
            <MenuText>{title}</MenuText>
          </Left>
          <Right>
            {<FaChevronDown />}
          </Right>
        </DropDownHead>
        <DropDownSubs isOpen={isOpen} childrenCount={childrenCount}>
          {
            children
          }
        </DropDownSubs>
      </Wrapper>
    );
  }
}

DropDownMenu.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
};

const Left = styled.div`
  display: flex;
  align-items: center;
`;
const Right = styled.div``;
const Wrapper = styled.div`
  user-select: none;
`;
const DropDownHead = styled.button`
  padding: 9px 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  border: none;
  width: 100%;
  outline: none;
  height: 44px;
  color: ${colors.sideBarIcon};
  :focus {
    outline: none;
  }
  :hover {
    background-color: #1a1a27;
  }
`;

const MenuText = styled.span`
  color: ${colors.sideBarText};
  font-size: 0.9rem;
  font-weight: 300;
`;
const IconWrapper = styled.span`
  display: flex;
  font-size: 20px;
  margin-right: 10px;
`;
const DropDownSubs = styled.div`
  height: ${props => (!props.isOpen ? 0 : `${props.childrenCount * 40}px`)};
  overflow: ${props => (!props.isOpen ? 'hidden' : 'auto')};
  transition: height .2s;
`;


export default DropDownMenu;
